var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-error-type-icon"},[_c('div',{staticClass:"asc-error-type-icon--single"},[_c('asc-icon',{attrs:{"icon":"square","color":_vm.getBgColor,"size":14}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }